import { useEffect, useState } from "react";
import { getBestSellerProducts } from "../../services/productService";
import "./BestSellerSection.css";

function BestSellerSection() {


const [products, setProducts] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
    loadProducts();
}, []);

const loadProducts = async () => {
    try {
        const response = await getBestSellerProducts();
        setProducts(response.data);
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

const handleAddToCart = (amazonLink) => {
    if (!amazonLink) {
        return;
    }

    window.open(
        amazonLink,
        "_blank",
        "noopener,noreferrer"
    );
};

if (loading) {
    return (
        <section className="best-seller-section">
            <h2>Our Best Sellers!</h2>
            <div className="loading">Loading Products...</div>
        </section>
    );
}

return (
    <section className="best-seller-section">

        <h2 className="section-title">
            Our Best Sellers!
        </h2>

        <div className="product-container">

            {products.map((product) => (

                <div
                    className="product-card"
                    key={product.id}
                >

                    {product.bestSeller && (
                        <span className="badge best-seller">
                            Best Seller
                        </span>
                    )}

                    {product.soldOut && (
                        <span className="badge sold-out">
                            Sold out
                        </span>
                    )}

                    {product.saveAmount > 0 && (
                        <span className="badge save-badge">
                            Save ₹{product.saveAmount}
                        </span>
                    )}

                    <div className="image-wrapper">
                        <img
                            src={product.imageUrl}
                            alt={product.productName}
                        />
                    </div>

                    <h3 className="product-name">
                        {product.productName}
                    </h3>

                    <div className="rating-section">

                        <span className="stars">
                            ★★★★★
                        </span>

                        <span className="rating-count">
                            {product.reviewCount} Ratings
                        </span>

                    </div>

                    <div className="rating-value">
                        {product.rating}
                        <span> ★</span>
                    </div>

                    <div className="price-section">

                        <span className="price">
                            ₹ {product.price}
                        </span>

                        {product.originalPrice > product.price && (
                            <span className="original-price">
                                MRP ₹ {product.originalPrice}
                            </span>
                        )}

                    </div>

                    <button
                        className="cart-btn"
                        disabled={product.soldOut || !product.amazonLink}
                        onClick={() =>
                            handleAddToCart(product.amazonLink)
                        }
                    >
                        {product.soldOut
                            ? "Sold Out"
                            : "Buy"}
                    </button>

                </div>

            ))}

        </div>

    </section>
);


}

export default BestSellerSection;
